var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout text-center"},[_c('div',{staticClass:"md-layout-item md-xlarge-size-40 md-large-size-40 md-medium-size-50 md-small-size-70 md-xsmall-size-100"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }